import React from 'react';
import { GraduationCap, Users } from 'lucide-react';
import { studentsByYear } from '../utils/mock';

const Students = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6" data-testid="students-page-title">
            Our <span className="text-cyan-400">Students</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Proud learners who trained with FutureBuildX in AI, Robotics, and IoT.
          </p>
        </div>
      </section>

      {/* Students by Year */}
      <section className="py-12 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {Object.entries(studentsByYear).map(([year, names]) => (
            <div key={year} className="mb-16">
              {/* Year Heading */}
              <div className="flex items-center justify-center mb-10">
                <div className="flex items-center space-x-3 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950/50 border border-cyan-500/30 rounded-2xl px-10 py-4">
                  <GraduationCap className="text-cyan-400" size={32} />
                  <h2 className="text-4xl font-bold text-white" data-testid={`students-year-heading-${year}`}>
                    {year}
                  </h2>
                </div>
              </div>

              {/* Student Count */}
              <div className="flex items-center justify-center space-x-2 text-gray-400 mb-8">
                <Users size={18} className="text-cyan-400" />
                <span data-testid={`students-count-${year}`}>{names.length} Students</span>
              </div>

              {/* Names Grid */}
              <div
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3"
                data-testid={`students-list-${year}`}
              >
                {names.map((name, index) => (
                  <div
                    key={index}
                    data-testid={`student-item-${year}-${index + 1}`}
                    className="flex items-center space-x-4 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950/50 border border-cyan-500/20 rounded-xl px-5 py-3 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/10"
                  >
                    <span className="flex-shrink-0 w-9 h-9 flex items-center justify-center bg-cyan-500/15 border border-cyan-500/30 rounded-full text-cyan-400 font-semibold text-sm">
                      {index + 1}
                    </span>
                    <span className="text-gray-200 text-sm font-medium">{name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Students;
